import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { CameraProvider } from "./contexts/CameraContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <CameraProvider>
          <App />
        </CameraProvider>
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// "homepage": "/salesrepapp",
// basename="/salesrepapp"
// http://nzen/salesrepapp/?device_token=U015UW9PV4JY9S9A&token=LGN103D12R6A17HG4CAI&SV=0

// https://3b6b4efa4b9a.ngrok-free.app/?device_token=S8RS2TT0SZ0805HN&token=34799Q9C95EVH3HGJJ7Z&SV=0
